<template>
  <div class="flex vertical center">
    <img v-if="smallEmpty" src="@/air/assets/img/common/empty.png" style="width: 100px; height: 100px;" />
    <img v-else src="@/air/assets/img/common/empty.png" style="width: 147px; height: 146px;" />
    <span class="font-14" style="color: #c9c9c9; margin-top: 20px">{{ $t('noData') }}</span>
  </div>
</template>

<script>
  export default {
    name: "bsp-empty",
    props: {
      smallEmpty: {
        type: Boolean,
        default: false
      }
    }
  }
</script>

<style scoped>

</style>
